export default {
  drawHeatMap() {
    let that = this;
    let xType;
    let currentMap = that.currentMap;
    that.$open();

    if (that.type === "板块热力") {
      if (that.value === "企业") {
        xType = "企业";
        that.max = 1;
        that.radius = 60;
      } else if (that.value === "大厦") {
        xType = "大厦";
        that.max = 1;
        that.radius = 30;
      } else if (that.value === "楼盘点击") {
        xType = "楼盘点击";
        // that.max = 5000;
        that.radius = 80;
      } else if (that.value === "楼盘中签率") {
        xType = "楼盘中签率";
        that.max = 60;
        that.radius = 100;
      }
    }
    console.log("xType", xType);
    if (!currentMap || !currentMap.remove) {
      console.log("err currentMap");
      return;
    }
    if (that.heatmap) {
      currentMap.remove(that.heatmap);
    }

    that.$axios
      .get(that.$url_prefix + "getHeatMapData", {
        params: {
          type: xType,
        },
      })
      .then(function (res) {
        let heatmapData = [];

        let myObject = {};
        if (xType === "企业" || xType === "大厦") {
          res.data.data.forEach((x) => {
            let temp = x.lnglat.split("|");
            let that = this;
            let id = x.area_id;
            if (!myObject[id]) {
              myObject[id] = [];
            }
            myObject[id].push({
              area_id: x.area_id,
              count: 1,
            });
            heatmapData.push({
              lng: parseFloat(temp[0]),
              lat: parseFloat(temp[1]),
              count: 1,
            });
          });
        } else if (xType === "楼盘点击") {
          res.data.data.forEach((x) => {
            let tempp = x.lnglat.split("-");
            let temp = tempp[0].split("|");
            let that = this;
            let id = x.area_id;
            if (!myObject[id]) {
              myObject[id] = [];
            }
            myObject[id].push({
              area_id: x.area_id,
              count: x.views_num,
            });
            heatmapData.push({
              lng: parseFloat(temp[0]),
              lat: parseFloat(temp[1]),
              count: 100000 + x.views_num,
            });
          });
        } else if (xType === "楼盘中签率") {
          res.data.data.forEach((x) => {
            let tempp = x.lnglat.split("-");
            let temp = tempp[0].split("|");
            let that = this;
            let id = x.area_id;
            if (!myObject[id]) {
              myObject[id] = [];
            }
            myObject[id].push({
              area_id: x.area_id,
              count: 101 - x.getRate,
            });
            heatmapData.push({
              lng: parseFloat(temp[0]),
              lat: parseFloat(temp[1]),
              count: x.getRate,
            });
          });
        }
        that.myObject = myObject;
        console.log("res", res);
        let heatmap = new AMap.Heatmap(); //在地图对象叠加热力图
        heatmap.setMap(currentMap);
        heatmap.setOptions({
          opacity: [0, 0.7], //改变透明度
          radius: that.radius, //热力点半径
          // gradient:{
          //   0.5: 'blue',
          //   0.65: 'rgb(0,255,255)',
          //   0.7: 'rgb(0, 255, 0)',
          //   0.9: 'rgb(255,255,0)',
          //   1.0: 'red'
          // }
        });
        heatmap.setDataSet({ data: heatmapData, max: that.max }); //设置热力图数据集
        that.heatmap = heatmap;
        that.$close();
        currentMap.clearMap();
        that.drawAreaPriceNew(currentMap, xType);
      })
      .catch(function (res) {
        console.log("所有地段 fail", res);
        that.$close();
      });
  },

  drawSchoolRealsHot(currentMap, date) {
    let that = this;
    that.$axios
      .post(
        that.$url_prefix + "queryschoolhot",
        { date: date },
        {
          timeout: 500000,
        }
      )
      .then((res) => {
        let data = res.data.data;
        console.log("学区热度", res.data);
        let mapData = {};
        for (let i = 0; i < data.schools.length; i++) {
          let loc = data.schools[i];
          let temp = loc;

          let realPos = loc.lnglat.split("-")[0].split("|");
          let position = realPos;
          if (loc.move) {
            position = loc.move.split("|");
            mapData[loc.id] = {
              marker: realPos,
              line: [realPos, position],
            };
          }

          let judges = [
            "#FF612C",
            "#FFA52D",
            "#FF612C",
            "#10CAE7",
            "#2358ED",
            "#486DFF",
          ];
          let judge = judges[loc.deal_hot_type - 1];
          if (parseFloat(loc.vsort) >= 4) {
            judge = "#FF612C";
          } else if (parseFloat(loc.vsort) >= 3) {
            judge = "#FFA52D";
          } else {
            judge = "#486DFF";
          }
          let name = loc.short || loc.location_name;

          if (
            loc.source_all_count === 0 &&
            loc.avg_source_price === 0 &&
            loc.deal_all_count === 0 &&
            loc.avg_deal_price === 0
          ) {
            continue;
          }

          let markerContent = `<div class="shape-container>
                <div class="rectangle" style="background-color:${judge}; border-radius: 12px;">
                  <div class="reclight">${name}</div>`;

          if (temp.source_all_count != 0 && temp.avg_source_price != 0) {
            markerContent += `<div class="reclight">挂牌 ${parseFloat(
              temp.avg_source_price / 10000
            ).toFixed(1)}万元/m² ${temp.source_all_count}套</div>`;
          } else if (temp.source_all_count != 0) {
            markerContent += `<div class="reclight">挂牌 ${temp.source_all_count}套</div>`;
          } else if (temp.avg_source_price != 0) {
            markerContent += `<div class="reclight">挂牌 ${parseFloat(
              temp.avg_source_price / 10000
            ).toFixed(1)}万元/m²</div>`;
          }

          if (temp.deal_all_count != 0 && temp.avg_deal_price != 0) {
            markerContent += `<div class="reclight">网签 ${parseFloat(
              temp.avg_deal_price / 10000
            ).toFixed(1)}万元/m² ${temp.deal_all_count}套</div>`;
          } else if (temp.deal_all_count != 0) {
            markerContent += `<div class="reclight">网签 ${temp.deal_all_count}套</div>`;
          } else if (temp.avg_deal_price != 0) {
            markerContent += `<div class="reclight">网签 ${parseFloat(
              temp.avg_deal_price / 10000
            ).toFixed(1)}万元/m²</div>`;
          }

          markerContent += `</div>
                </div>`;

          let marker = new AMap.Marker({
            real_id: loc.id,
            position: position,
            content: markerContent,
            offset: new AMap.Pixel(-10, -10),
            draggable: true,
          });

          marker.on("dragstart", (e) => {
            console.log("开始移动", e.target.w.real_id);
            let real_id = e.target.w.real_id;
            if (!that.schoolMarkers[real_id]) {
              let dot = loc.lnglat.split("-")[0].split("|");
              let temp = JSON.parse(JSON.stringify(that.schoolMarkers));
              temp[real_id] = {
                marker: dot,
                line: [dot, dot],
              };
              that.schoolMarkers = temp;
            }
          });
          marker.on("dragging", (e) => {
            let real_id = e.target.w.real_id;
            let temp = JSON.parse(JSON.stringify(that.schoolMarkers));
            temp[real_id].line[1] = [e.lnglat.lng, e.lnglat.lat];
            that.schoolMarkers = temp;
          });
          marker.on("dragend", (e) => {
            console.log("移动结束", that.schoolMarkers);
            let real_id = e.target.w.real_id;
            let temp = JSON.parse(JSON.stringify(that.schoolMarkers));
            let pos = e.target.getPosition();
            temp[real_id].line[1] = [pos.lng, pos.lat];
            that.schoolMarkers = temp;
            that.saveNewSchoolMarkers(real_id);
          });
          marker.on("rightclick", (e) => {
            console.log("右击", e);
            let real_id = e.target.w.real_id;
            if (that.schoolMarkers[real_id]) {
              let temp = JSON.parse(JSON.stringify(that.schoolMarkers));
              e.target.setPosition(temp[real_id].marker);
              delete temp[real_id];
              that.schoolMarkers = temp;
              that.saveNewSchoolMarkers(real_id);
            }
          });

          marker.setMap(currentMap);
        }

        // for (let i = 0; i < data.area_list.length; i++) {
        //   let temp = data.area_list[i]
        //   let judges = ['#FFA73B','#FFF552', '#87FFAC', '#14EFFF', '#274BFF', '#447CFF','#6CAEFF']
        //   let judge = judges[temp.hot_type - 1];
        //   let dots = temp.dots.split('-').map(x => {
        //     return x.split('|')
        //   })
        //   let polygon = new AMap.Polygon({
        //     path: dots,
        //     fillOpacity: 0.2,
        //     fillColor: '#B5B5B5',
        //     strokeWeight: 2,
        //     strokeOpacity: 1,
        //     strokeColor: '#4C4C4C'
        //   })
        //   currentMap.add(polygon)
        // }

        that.schoolMarkers = mapData;
      });
  },

  drawAreaAllHot(currentMap, date) {
    let that = this;
    that.$axios
      .post(
        that.$url_prefix + "queryareahot",
        { date: date },
        {
          timeout: 500000,
        }
      )
      .then((res) => {
        let data = res.data.data;
        console.log("板块热度", data);
        for (let i = 0; i < data.length; i++) {
          let temp = data[i];

          // 板块区域
          let dots = temp.dots.split("-").map((x) => {
            return x.split("|");
          });
          let judges = [
            "#FFA73B",
            "#FFF552",
            "#87FFAC",
            "#14EFFF",
            "#274BFF",
            "#447CFF",
          ];
          let judge = judges[temp.deal_hot_type - 1];
          let polygon = new AMap.Polygon({
            path: dots,
            fillOpacity: 0.2,
            fillColor: "#B5B5B5",
            strokeWeight: 2,
            strokeOpacity: 1,
            strokeColor: "#4C4C4C",
          });

          let polygon2 = new AMap.Polygon({
            // 底色
            map: currentMap,
            strokeWeight: 3,
            path: dots,
            fillOpacity: 0.7,
            fillColor: judge,
            strokeOpacity: 0,
          });

          currentMap.add(polygon);
          currentMap.add(polygon2);

          let markerContent = `<div class="shape-container>
                <div class="rectangle" style="border-radius: 12px">
                  <div class="reclight_area">${temp.area_name}</div>`;

          if (temp.source_all_count != 0 && temp.avg_source_price != 0) {
            markerContent += `<div class="reclight">挂牌 ${parseFloat(
              temp.avg_source_price / 10000
            ).toFixed(1)}万 ${temp.source_all_count}套</div>`;
          } else if (temp.source_all_count != 0) {
            markerContent += `<div class="reclight">挂牌 ${temp.source_all_count}套</div>`;
          } else if (temp.avg_source_price != 0) {
            markerContent += `<div class="reclight">挂牌 ${parseFloat(
              temp.avg_source_price / 10000
            ).toFixed(1)}万</div>`;
          }

          if (temp.deal_all_count != 0 && temp.avg_deal_price != 0) {
            markerContent += `<div class="reclight">网签 ${parseFloat(
              temp.avg_deal_price / 10000
            ).toFixed(1)}万 ${temp.deal_all_count}套</div>`;
          } else if (temp.deal_all_count != 0) {
            markerContent += `<div class="reclight">网签 ${temp.deal_all_count}套</div>`;
          } else if (temp.avg_deal_price != 0) {
            markerContent += `<div class="reclight">网签 ${parseFloat(
              temp.avg_deal_price / 10000
            ).toFixed(1)}万</div>`;
          }

          markerContent += `</div>
                </div>`;

          let offsetX = -40;
          let offsetY = -30;
          let temp_arr = ["湖滨", "文晖"];
          if (temp_arr.includes(temp.area_name)) {
            offsetX = -75;
            offsetY = -55;
          }

          if (temp.area_name == "智慧网谷") {
            offsetX = -90;
            offsetY = -50;
          }

          if (temp.area_name == "武林") {
            offsetY = -80;
          }

          if (temp.area_name == "望江新城") {
            offsetX = -45;
            offsetY = -35;
          }

          if (temp.area_name == "崇贤新城") {
            offsetY = -60;
          }

          let marker = new AMap.Marker({
            position: temp.center.split("-")[0].split("|"),
            content: markerContent,
            offset: new AMap.Pixel(offsetX, offsetY),
            draggable: true,
          });
          marker.setMap(currentMap);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },

  drawOneAreaAll(currentMap, area_id) {
    let that = this;
    that.$axios
      .post(
        that.$url_prefix + "queryareaalldata",
        { area_id: area_id },
        { timeout: 500000 }
      )
      .then((res) => {
        let data = res.data.data;
        console.log("单个板块", data);
        for (let i = 0; i < data["area_list"].length; i++) {
          let temp = data["area_list"][i];

          if (temp.id !== area_id) {
            continue;
          }

          // 板块区域
          let dots = temp.dots.split("-").map((x) => {
            return x.split("|");
          });
          console.log("dotsdots", dots);

          let judges = [
            "#FFA73B",
            "#FFF552",
            "#87FFAC",
            "#14EFFF",
            "#274BFF",
            "#447CFF",
          ];
          let polygon = new AMap.Polygon({
            path: dots,
            fillOpacity: 0.2,
            fillColor: "#B5B5B5",
            strokeWeight: 15,
            strokeOpacity: 1,
            strokeStyle: "dashed",
            strokeColor: "#FF0000",
          });

          currentMap.add(polygon);
          currentMap.setFitView([polygon], false, [0, 0, 0, 0]);
        }

        for (let i = 0; i < data["estates"].length; i++) {
          let temp = data["estates"][i];
          if (
            temp.source_count === 0 &&
            temp.avg_source_price === 0 &&
            temp.deal_count === 0 &&
            temp.avg_deal_price === 0
          ) {
            continue;
          }

          // let judges = ['#FFA73B','#FFF552', '#87FFAC', '#14EFFF', '#274BFF', '#447CFF','#6CAEFF']
          let judges = ["#43fd3e", "#ffae2e", "#FFA52D", "#486DFF"];
          let num = 0;
          if (temp.type === "二手房") {
            num = 1;
            temp.showtype = "老盘";
          } else {
            num = 2;
            temp.showtype = "次新";
          }

          let judge = judges[num - 1];

          let markerContent = `<div class="shape-container>
                <div class="rectangle1" style="background-color:${judge}; border-radius: 12px;">
                  <div class="reclight1">${temp.estate.real_estate_name}(${temp.showtype})</div>`;

          if (temp.source_count != 0 && temp.avg_source_price != 0) {
            markerContent += `<div class="reclight1">挂牌 ${parseFloat(
              temp.avg_source_price / 10000
            ).toFixed(1)}万元/m² ${temp.source_count}套</div>`;
          } else if (temp.source_count != 0) {
            markerContent += `<div class="reclight1">挂牌 ${temp.source_count}套</div>`;
          } else if (temp.avg_source_price != 0) {
            markerContent += `<div class="reclight1">挂牌 ${parseFloat(
              temp.avg_source_price / 10000
            ).toFixed(1)}万元/m²</div>`;
          }

          if (temp.deal_count != 0 && temp.avg_deal_price != 0) {
            markerContent += `<div class="reclight1">网签 ${parseFloat(
              temp.avg_deal_price / 10000
            ).toFixed(1)}万元/m² ${temp.deal_count}套</div>`;
          } else if (temp.deal_count != 0) {
            markerContent += `<div class="reclight1">网签 ${temp.deal_count}套</div>`;
          } else if (temp.avg_deal_price != 0) {
            markerContent += `<div class="reclight1">网签 ${parseFloat(
              temp.avg_deal_price / 10000
            ).toFixed(1)}万元/m²</div>`;
          }

          markerContent += `</div>
                </div>`;

          let marker = new AMap.Marker({
            position: temp.estate.lnglat.split("-")[0].split("|"),
            content: markerContent,
            offset: new AMap.Pixel(0, 0),
            draggable: true,
          });
          marker.setMap(currentMap);
        }
        for (let i = 0; i < data["newEstates"].length; i++) {
          let temp = data["newEstates"][i];
          let judge = "#ff000e";
          let markerContent = `<div class="shape-container>
                <div class="rectangle1" style="background-color:${judge}; border-radius: 12px;">
                  <div class="reclight1">${temp.real_estate_name}(${temp.type})</div>`;
          if (temp.priceArr && temp.priceArr.length > 0) {
            for (let index = 0; index < temp.priceArr.length; index++) {
              const element = temp.priceArr[index];
              markerContent += `<div class="reclight1">${element}</div>`;
            }
          } else {
            markerContent += `<div class="reclight1">暂无价格</div>`;
          }

          markerContent += `</div>
                </div>`;

          let marker = new AMap.Marker({
            position: temp.lnglat.split("-")[0].split("|"),
            content: markerContent,
            offset: new AMap.Pixel(0, 0),
            draggable: true,
          });
          marker.setMap(currentMap);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },

  drawOneSchoolAll(currentMap, school_id) {
    let that = this;
    that.$axios
      .post(that.$url_prefix + "querySchoolAllData", { id: school_id })
      .then((res) => {
        console.log("querySchoolAllData", res);
        let data = res.data;
        if (data.school) {
          let temp = data.school;
          // 板块区域
          if (temp.dots) {
            let dots = JSON.parse(temp.dots);
            const coordinates = dots.map((subArray) => {
              return subArray.map((coordStr) => {
                return coordStr.split("|");
              });
            });
            console.log("dotsdots", coordinates);
            // let dots = temp.dots.split("-").map((x) => {
            //   return x.split("|");
            // });
            let polygon = new AMap.Polygon({
              path: coordinates,
              fillOpacity: 0.2,
              fillColor: "#B5B5B5",
              strokeWeight: 15,
              strokeOpacity: 1,
              strokeStyle: "dashed",
              strokeColor: "#FF0000",
            });

            currentMap.add(polygon);
            currentMap.setFitView([polygon], false, [0, 0, 0, 0]);
          }
        }

        for (let i = 0; i < data["oldEstate"].length; i++) {
          let temp = data["oldEstate"][i];
          if (
            temp.source_count === 0 &&
            temp.avg_source_price === 0 &&
            temp.deal_count === 0 &&
            temp.avg_deal_price === 0
          ) {
            continue;
          }

          // let judges = ['#FFA73B','#FFF552', '#87FFAC', '#14EFFF', '#274BFF', '#447CFF','#6CAEFF']
          let judges = ["#43fd3e", "#ffae2e", "#FFA52D", "#486DFF"];
          let num = 0;
          if (temp.type === "二手房") {
            num = 1;
            temp.showtype = "老盘";
          } else {
            num = 2;
            temp.showtype = "次新";
          }

          let judge = judges[num - 1];

          let markerContent = `<div class="shape-container>
                <div class="rectangle1" style="background-color:${judge}; border-radius: 12px;">
                  <div class="reclight1">${temp.estate.real_estate_name}(${temp.showtype})</div>`;

          if (temp.source_count != 0 && temp.avg_source_price != 0) {
            markerContent += `<div class="reclight1">挂牌 ${parseFloat(
              temp.avg_source_price / 10000
            ).toFixed(1)}万元/m² ${temp.source_count}套</div>`;
          } else if (temp.source_count != 0) {
            markerContent += `<div class="reclight1">挂牌 ${temp.source_count}套</div>`;
          } else if (temp.avg_source_price != 0) {
            markerContent += `<div class="reclight1">挂牌 ${parseFloat(
              temp.avg_source_price / 10000
            ).toFixed(1)}万元/m²</div>`;
          }

          if (temp.deal_count != 0 && temp.avg_deal_price != 0) {
            markerContent += `<div class="reclight1">网签 ${parseFloat(
              temp.avg_deal_price / 10000
            ).toFixed(1)}万元/m² ${temp.deal_count}套</div>`;
          } else if (temp.deal_count != 0) {
            markerContent += `<div class="reclight1">网签 ${temp.deal_count}套</div>`;
          } else if (temp.avg_deal_price != 0) {
            markerContent += `<div class="reclight1">网签 ${parseFloat(
              temp.avg_deal_price / 10000
            ).toFixed(1)}万元/m²</div>`;
          }

          markerContent += `</div>
                </div>`;

          let marker = new AMap.Marker({
            position: temp.estate.lnglat.split("-")[0].split("|"),
            content: markerContent,
            offset: new AMap.Pixel(0, 0),
            draggable: true,
          });
          marker.setMap(currentMap);
        }
        if (data["newEstate"] && data["newEstate"].length) {
          for (let i = 0; i < data["newEstate"].length; i++) {
            let temp = data["newEstate"][i];
            let judge = "#ff000e";
            let markerContent = `<div class="shape-container>
                <div class="rectangle1" style="background-color:${judge}; border-radius: 12px;">
                  <div class="reclight1">${temp.real_estate_name}(${temp.type})</div>`;
            if (temp.priceArr && temp.priceArr.length > 0) {
              for (let index = 0; index < temp.priceArr.length; index++) {
                const element = temp.priceArr[index];
                markerContent += `<div class="reclight1">${element}</div>`;
              }
            } else {
              markerContent += `<div class="reclight1">暂无价格</div>`;
            }

            markerContent += `</div>
                </div>`;

            let marker = new AMap.Marker({
              position: temp.lnglat.split("-")[0].split("|"),
              content: markerContent,
              offset: new AMap.Pixel(0, 0),
              draggable: true,
            });
            marker.setMap(currentMap);
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  },
}



// WEBPACK FOOTER //
// ./src/page/makeLocationImage/methods/bindHeatmap.js